import { executionMetadata } from '@/frontend/features/Fde/investigations/executionPresentation'
import type { InvestigationExecution, InvestigationLabels } from '@/frontend/features/Fde/investigations/types'

export default function ExecutionMetadata({ execution, copy }: { execution: InvestigationExecution; copy: InvestigationLabels }) {
  const rows = executionMetadata(execution, copy)
  if (rows.length === 0) return null
  return <details className="min-w-0 border-t border-border pt-2">
    <summary className="w-fit cursor-pointer text-[11px] text-muted-foreground">{copy.technical_details}</summary>
    <dl className="mt-3 grid gap-2 text-[11px]">
      {rows.map(([label, value]) => <div key={label} className="grid gap-0.5 sm:grid-cols-[minmax(0,160px)_minmax(0,1fr)] sm:gap-3"><dt className="text-muted-foreground">{label}</dt><dd className="break-all font-mono tabular-nums">{value}</dd></div>)}
    </dl>
  </details>
}
